import { useSelector } from 'react-redux'
import { isAdmin, isAuthenticated } from 'session'
import { IStoreState } from '../store'

export const useAuthStatus = () => {
  const admin = useSelector<IStoreState, boolean>((state) =>
    isAdmin(state.session)
  )
  const authenticated = useSelector<IStoreState, boolean>((state) =>
    isAuthenticated(state.session)
  )
  return { admin, authenticated }
}
